export interface ToolbarButton {
  key: string;
  link: string;
  status?: string;
}

// Configuración de botones del toolbar
export const toolbarButtons: ToolbarButton[] = [
  { key: 'all', link: '#' },
  { key: 'pending', link: '#', status: 'PENDING' },
  { key: 'verified', link: '#', status: 'VERIFIED' },
  { key: 'rejected', link: '#', status: 'REJECTED' },
  { key: 'disabled', link: '#', status: 'DISABLED' },
];

